import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import {
  HELP_SECTION_APPLY_CODES,
  HELP_TOPIC_APPLY_CODES,
  HELP_TOPIC_APPLY_CODES_SIGN_IN,
  HELP_TOPIC_APPLY_CODES_REGISTER,
  HELP_TOPIC_APPLY_CODES_AUTHORIZE_CODES,
  HELP_TOPIC_APPLY_CODES_REQUEST_CODES,
  HELP_TOPIC_APPLY_CODES_UPLOAD_CODES,
} from '@app/constants';

const ApplyCodesSection = ({ activeTopic, scrollToTopic }) => {
  useEffect(() => {
    activeTopic && scrollToTopic(activeTopic);
  }, [activeTopic, scrollToTopic]);

  return (
    <div id={HELP_SECTION_APPLY_CODES} className="help-section">
      <div id={HELP_TOPIC_APPLY_CODES} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes" tagName="h2" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-option-1" tagName="h4" />
          <LocalizedText id="qau-help-topic-apply-codes-option-1-p1" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-option-1-p2" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-option-1-p3" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-option-2" tagName="h4" />
          <LocalizedText id="qau-help-topic-apply-codes-option-2-p1" tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_SIGN_IN} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-sign-in" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-sign-in-p1" tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_REGISTER} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-register" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-register-p1" tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_AUTHORIZE_CODES} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-authorize-codes" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-authorize-codes-p1" tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_REQUEST_CODES} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-request-codes" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p1" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p2" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p3" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p4" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p5" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p6" tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_UPLOAD_CODES} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-upload-codes" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p1" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p2" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p3" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p4" tagName="p" />
        </div>
      </div>
    </div>
  );
};

ApplyCodesSection.propTypes = {
  scrollToTopic: PropTypes.func.isRequired,
  activeTopic: PropTypes.string,
};

export default ApplyCodesSection;
